import { useCallback } from "react";
import { Flex, Box, useToast } from "@chakra-ui/react";

import InfoCard from "@components/InfoCard";
import Icon from "@components/Icon";

import { InfoCardBody } from "theme";

import { SmartContractItems } from "@customtypes/common";
import { CONTRACT_ADDRESS_CLICK } from "@constants/analytics";

import { copyToClipboard } from "@utils/common";
import { trackEvent } from "dapp-sdk-v2";

interface ContractsCardProps {
  title?: string;
  contractItems: SmartContractItems[];
}

const ContractsCard = ({ title, contractItems }: ContractsCardProps) => {
  const toast = useToast();

  const handleAddressCopy = useCallback(
    (address: string | undefined, title: string) => {
      if (!address) return;
      copyToClipboard(address);
      trackEvent(CONTRACT_ADDRESS_CLICK, {
        title: title,
      });
      toast({
        description: "Address Copied",
        status: "success",
        duration: 2000,
        position: "top",
        isClosable: false,
      });
    },
    [toast]
  );

  return (
    <InfoCard title={title}>
      <InfoCardBody>
        <Flex justifyContent="space-between" maxW="400px">
          {contractItems.map((data) => (
            <Box
              key={data.address}
              h-="32px"
              w="32px"
              cursor="pointer"
              onClick={() => handleAddressCopy(data.address, data.title)}
            >
              <Icon width="100%" height="100%" Icon={data.icon} />
            </Box>
          ))}
        </Flex>
      </InfoCardBody>
    </InfoCard>
  );
};

export default ContractsCard;
